import {
  logError,
  logOperationalEvent,
  logWarn,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';

export const createVideoPlayerLogger = (component: string) => ({
  // VideoPlayer passes context like `errorCode`/`videoSrc` here. Spread first so
  // `error`, `message` and the consumer's `component` always win — the player also
  // sends a generic `component: 'video_player'` we don't want.
  logError: (error: Error, optionalFields?: { [field: string]: string | number }) => {
    logError({ ...optionalFields, error, message: error.message, component });
  },
  logWarn: (fields: { [field: string]: string | number; message: string; component: string }) => {
    logWarn(fields);
  },
  logOperationalEvent: (fields: { [field: string]: string | number; eventName: string }) => {
    logOperationalEvent(fields);
  },
});
